import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { EmailOtpSteps } from "../../../interfaces/interfaces";
import styles from "./CheckForwardingEmailSet.module.scss";
import { TextCopy } from "./emailOtpHelper";

type Props = {
	setStep: React.Dispatch<React.SetStateAction<{
		currentStep: number;
		previousStep: number;
	}>>;
}

export const CheckForwardingEmailSet = ({ setStep }: Props) => {
	return (
		<div className={styles.rootContainer}>
			<div className={styles.headerContainer}>
				<div className={styles.ipLogoContainer}>
					<img src="https://assets.clickmerito.com/images/gmail.png" alt="" />
				</div>
				<div className={styles.headerText}>Check if Forwarding Email is Set</div>
			</div>
			<div className={styles.bodyTextContainer}>
				<div className={styles.text}>
					You must add  <span><TextCopy text="helpdesk@clickmerito.com" /></span> as a forwarding
					address before continuing.
				</div>
				<div className={styles.instructionContainer}>
					<p>If you’ve done this earlier, follow these steps to verify:</p>
					<ol>
						<li>
							Go to the <strong>Forwarding</strong> section in your email settings.
						</li>
						<li>
							Check if <strong>helpdesk@clickmerito.com</strong> appears in the list.
						</li>
					</ol>
					<div className={styles.text}><strong>Only skip</strong> if you see helpdesk@clickmerito.com in the list.</div>
				</div>
			</div>
			<div className={styles.imgContainer}>
				<img src={"https://assets.clickmerito.com/emailOtpSteps/emailforwardError.png?q=1"} alt="" />
			</div>
			{/* Paste Image of the Forwarding Section on Gmail */}
			<div className={styles.footerBtnContainer}>
				<div className={styles.leftContainer}>
					<MeritoButton
						type="secondary-2"
						btnText="Back"
						onClick={() =>
							setStep(prev => ({
								currentStep: EmailOtpSteps.credential,
								previousStep: prev.currentStep,
							}))
						}
						isRounded={true}
						size="lg"
					/>
				</div>
				<div className={styles.rightContainer}>
					<MeritoButton
						type="secondary-2"
						btnText="Skip Set Up"
						onClick={() => {
							setStep(prev => ({
								currentStep: EmailOtpSteps.gmailFilterGif1,
								previousStep: prev.currentStep,
							}))
						}}
						isRounded={true}
						size="lg"
					/>
					<MeritoButton
						type="primary-1"
						btnText="Set Up Now"
						onClick={() => {
							setStep(prev => ({
								currentStep: EmailOtpSteps.emailForwardGif1,
								previousStep: prev.currentStep,
							}))
						}}
						isRounded={true}
						size="lg"
					/>
				</div>
			</div>
		</div>
	);
};
